import { ButtonContainer, Container } from './styles';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import ErrorMessageComponent from './ErrorMessage';
import { useEffect, useState } from 'react';
import HelpHeader from 'src/common/components/help-header';
import { useRouter } from 'next/router';

interface IError {
  error?: any;
  handleClick: any;
}

const ErrorPage = ({ error, handleClick }: IError) => {
  const [errorMsg, setErrorMsg] = useState('');
  const router = useRouter();

  useEffect(() => {
    if (error) {
      if (error?.response?.status !== 500) {
        const msg = error?.response?.data?.message || error?.message;
        setErrorMsg(msg);
      }
    }
  }, [error]);

  return (
    <Container>
      <HelpHeader
        disableBack
        sendEvent={() => {}}
        handleBack={() => router.back()}
        styles={{ maxWidth: '480px' }}
      />
      <ErrorMessageComponent
        title={'Uh-oh! Looks like something went wrong.'}
        desc={errorMsg}
      />
      <ButtonContainer onClick={handleClick}>
        <PrimaryButton isFullWidth>{'Go to homepage'}</PrimaryButton>
      </ButtonContainer>
    </Container>
  );
};

export default ErrorPage;
